/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ list: NonNullable<unknown> }} Evidenceinlinewithsuggestion3Inputs */

const en_evidenceinlinewithsuggestion3 = /** @type {(inputs: Evidenceinlinewithsuggestion3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Strengthen this with a ${i?.list} →`)
};

const pt_evidenceinlinewithsuggestion3 = /** @type {(inputs: Evidenceinlinewithsuggestion3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Reforçar com ${i?.list} →`)
};

/**
* | output |
* | --- |
* | "Strengthen this with a {list} →" |
*
* @param {Evidenceinlinewithsuggestion3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const evidenceinlinewithsuggestion3 = /** @type {((inputs: Evidenceinlinewithsuggestion3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Evidenceinlinewithsuggestion3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_evidenceinlinewithsuggestion3(inputs)
	return pt_evidenceinlinewithsuggestion3(inputs)
});
export { evidenceinlinewithsuggestion3 as "evidenceInlineWithSuggestion" }